var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-item",class:{'is-active': _vm.active},style:({width: (_vm.width + "px")})},[(_vm.ready)?_c('div',{staticClass:"swiper-item__container"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }